import { FirebaseUser } from './FirebaseUser';
import { REDUCER_KEY } from './actions';
import { FirebaseUserState } from './reducer';

// Directly expose the user property from the Redux state
export const selectFirebaseUser = (
  state: { [REDUCER_KEY]: FirebaseUserState },
): FirebaseUser | undefined => state[REDUCER_KEY].user;
